import {
  PHARMA_FETCH_ALL_MAIL_SUCCESS,
  PHARMA_GET_ALL_MAIL,
  PHARMA_GET_IMPORTANT_MAIL,
  PHARMA_GET_NAV_FILTERS,
  PHARMA_GET_NAV_FOLDER,
  PHARMA_GET_NAV_LABELS,
  PHARMA_GET_READ_MAIL,
  PHARMA_GET_STARRED_MAIL,
  PHARMA_GET_UNIMPORTANT_MAIL,
  PHARMA_GET_UNREAD_MAIL,
  PHARMA_GET_UNSELECTED_ALL_MAIL,
  PHARMA_GET_UNSTARRED_MAIL,
  PHARMA_HANDLE_REQUEST_CLOSE,
  PHARMA_ON_ALL_MAIL_SELECT,
  PHARMA_ON_COMPOSE_MAIL,
  PHARMA_ON_DELETE_MAIL,
  PHARMA_ON_FOLDER_MENU_ITEM_SELECT,
  PHARMA_ON_FOLDER_SELECT,
  ON_HIDE_LOADER,
  PHARMA_ON_IMPORTANT_SELECT,
  PHARMA_ON_LABEL_MENU_ITEM_SELECT,
  PHARMA_ON_LABEL_SELECT,
  PHARMA_ON_MAIL_CHECKED,
  PHARMA_ON_MAIL_SELECT,
  PHARMA_ON_MAIL_SEND,
  PHARMA_ON_OPTION_MENU_SELECT,
  PHARMA_ON_START_SELECT,
  ON_TOGGLE_DRAWER,
  PHARMA_SEARCH_MAIL,
  PHARMA_SET_CURRENT_MAIL_NULL,
  SHOW_MESSAGE,
  UPDATE_SEARCH,
  PHARMA_FETCH_ALL_MAIL,
  PHARMA_PROCESS_STATE_CHANGE,
  PHARMA_PATIENT_CONTACT_SAVE,
} from "constants/ActionTypes";
import mails from "app/routes/psp/managepharma/data/mails";

const INIT_STATE = {
  searchMail: "",
  noContentFoundMessage: "No hay pacientes en este espacio",
  alertMessage: "",
  showMessage: false,
  drawerState: false,
  anchorEl: null,
  // allMail: [], only for prod
  allMail: mails,
  optionName: "None",
  loader: false,
  currentMail: null,
  user: {
    name: "Robert Johnson",
    email: "robert@example.com",
    avatar: "https://via.placeholder.com/150x150",
  },
  selectedMails: 0,
  selectedFolder: 0,
  composeMail: false,
  labelMenuState: false,
  folderMenuState: false,
  optionMenuState: false,
  // folderMails: [], //only for prod
  folderMails: mails.filter((mail) => mail.folder === 0),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PHARMA_GET_ALL_MAIL: {
      let mails = state.allMail.map((mail) =>
        mail.folder === state.selectedFolder
          ? {
              ...mail,
              selected: true,
            }
          : mail
      );
      return {
        ...state,
        selectedMails: mails.length,
        optionName: "All",
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
        loader: false,
      };
    }
    case PHARMA_FETCH_ALL_MAIL: {
      return {
        ...state,
        loader: false,
        folderMails: state.allMail.filter((mail) => mail.folder === 0),
      };
    }
    case PHARMA_FETCH_ALL_MAIL_SUCCESS: {
      return {
        ...state,
        loader: false,
        allMail: action.payload,
        folderMails: action.payload.filter((mail) => mail.folder === 0),
      };
    }
    case PHARMA_GET_IMPORTANT_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (mail.important) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        optionName: "Important",
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_NAV_FILTERS: {
      console.log("-----------", action.payload);
      const filterMails = state.allMail.filter((mail) => {
        if (action.payload.id === 0 && mail.starred) {
          return mail;
        } else if (action.payload.id === 1 && mail.important) {
          return mail;
        } else return null;
      });
      //console.log("-----------", filterMails);
      return {
        ...state,
        noContentFoundMessage: "No hay pacientes en este espacio",
        loader: true,
        folderMails: filterMails,
      };
    }
    case PHARMA_ON_FOLDER_SELECT: {
      return { ...state, folderMenuState: !state.folderMenuState };
    }
    case PHARMA_GET_NAV_LABELS: {
      const filterMails = state.allMail.filter((mail) =>
        mail.labels.includes(action.payload.id)
      );
      return {
        ...state,
        loader: true,
        noContentFoundMessage: "No hay pacientes en este espacio",
        folderMails: filterMails,
      };
    }
    case PHARMA_GET_READ_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (mail.read) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        allMail: mails,
        optionName: "Read",
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_STARRED_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (mail.starred) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        allMail: mails,
        optionName: "Stared",
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_UNIMPORTANT_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (!mail.important) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        allMail: mails,
        optionName: "Unimportant",
        noContentFoundMessage: "No hay pacientes en este espacio",
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_UNREAD_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (!mail.read) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        allMail: mails,
        optionName: "Unread",
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_UNSELECTED_ALL_MAIL: {
      let mails = state.allMail.map((mail) =>
        mail.folder === state.selectedFolder
          ? {
              ...mail,
              selected: false,
            }
          : mail
      );
      return {
        ...state,
        selectedMails: 0,
        optionName: "None",
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_GET_UNSTARRED_MAIL: {
      let selectedMail = 0;
      let mails = state.allMail.filter(
        (mail) => mail.folder === state.selectedFolder
      );
      mails = mails.map((mail) => {
        if (!mail.starred) {
          selectedMail++;
          return { ...mail, selected: true };
        }
        return { ...mail, selected: false };
      });
      return {
        ...state,
        selectedMails: selectedMail,
        optionName: "UnStarred",
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_HANDLE_REQUEST_CLOSE: {
      return {
        ...state,
        composeMail: false,
        showMessage: false,
        folderMenuState: false,
        labelMenuState: false,
        optionMenuState: false,
      };
    }
    case PHARMA_ON_ALL_MAIL_SELECT: {
      return { ...state };
    }
    case PHARMA_ON_FOLDER_MENU_ITEM_SELECT: {
      const mails = state.allMail.map((mail) =>
        mail.selected && mail.folder === state.selectedFolder
          ? { ...mail, folder: action.payload, selected: false }
          : mail
      );

      return {
        ...state,
        selectedMails: 0,
        allMail: mails,
        noContentFoundMessage: "No hay pacientes en este espacio",
        alertMessage: "Mail has been moved successfully",
        showMessage: true,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_ON_IMPORTANT_SELECT: {
      action.payload.important = !action.payload.important;
      return {
        ...state,
        alertMessage: action.payload.important
          ? "Mail Mark as Important"
          : "Mail Remove as Important",
        showMessage: true,
        folderMails: state.folderMails.map((mail) =>
          mail.id === action.payload.id ? action.payload : mail
        ),
      };
    }
    case PHARMA_ON_LABEL_MENU_ITEM_SELECT: {
      let currentMail = state.currentMail;
      const mails = state.allMail.map((mail) => {
        if (mail.selected && mail.folder === state.selectedFolder) {
          console.log("selected", currentMail);
          if (mail.labels.includes(action.payload.id)) {
            mail.labels.splice(mail.labels.indexOf(action.payload.id), 1);
            if (currentMail !== null && mail.id === currentMail.id) {
              currentMail.labels = mail.labels;
            }
            return { ...mail, labels: mail.labels };
          } else {
            mail.labels = mail.labels.concat(action.payload.id);
            if (currentMail !== null && mail.id === currentMail.id) {
              currentMail.labels = mail.labels;
            }
            return { ...mail, labels: mail.labels };
          }
        } else {
          return mail;
        }
      });

      return {
        ...state,
        currentMail: currentMail,
        noContentFoundMessage: "No hay pacientes en este espacio",
        alertMessage: "Label Updated Successfully",
        showMessage: true,
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_PROCESS_STATE_CHANGE: {
      let currentMail = state.currentMail;
      const mails = state.allMail.map((mail) => {
        const labelSelected = action.payload[0].id;

        if (currentMail !== null && mail.id === currentMail.id) {
          if (mail.labels.includes(labelSelected)) {
            mail.labels.splice(mail.labels.indexOf(labelSelected), 1);
            currentMail.labels = mail.labels;
          } else {
            mail.labels = mail.labels.concat(labelSelected);
            currentMail.labels = mail.labels;
          }

          const stateSelected = action.payload[0].id;
          if (!mail.states.includes(stateSelected)) {
            mail.states = mail.states.concat(stateSelected);
            currentMail.states = mail.states;
          }

          return { ...mail, labels: mail.labels, states: mail.states };
        } else {
          return mail;
        }
      });

      return {
        ...state,
        currentMail: currentMail,
        noContentFoundMessage: "No hay pacientes en este espacio",
        alertMessage: "Operación exitosa",
        showMessage: true,
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_PATIENT_CONTACT_SAVE: {
      let currentMail = state.currentMail;
      const mails = state.allMail.map((mail) => {
        if (currentMail !== null && mail.id === currentMail.id) {
          mail.from.name = action.payload.name ?? mail.from.name;
          mail.from.lastname = action.payload.lastname ?? mail.from.lastname;
          mail.hasPatient = action.payload.hasPatient ?? mail.hasPatient;
          mail.date = action.payload.date ?? mail.date;
          mail.folder = action.payload.folder ?? mail.folder;
        }
        return { ...mail };
      });

      return {
        ...state,
        currentMail: currentMail,
        alertMessage: "Operación exitosa",
        showMessage: true,
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_ON_LABEL_SELECT: {
      return { ...state, labelMenuState: !state.labelMenuState };
    }
    case PHARMA_ON_MAIL_CHECKED: {
      action.payload.selected = !action.payload.selected;
      let selectedMail = 0;
      const mails = state.folderMails.map((mail) => {
        if (mail.selected) {
          selectedMail++;
        }
        if (mail.id === action.payload.id) {
          if (mail.selected) {
            selectedMail++;
          }
          return action.payload;
        } else {
          return mail;
        }
      });
      return {
        ...state,
        selectedMails: selectedMail,
        folderMails: mails,
      };
    }

    case PHARMA_ON_MAIL_SELECT: {
      return {
        ...state,
        loader: true,
        currentMail: action.payload,
      };
    }
    case PHARMA_ON_MAIL_SEND: {
      return {
        ...state,
        alertMessage: "Mail Sent Successfully",
        showMessage: true,
        folderMails: state.allMail.concat(action.payload),
        allMail: state.allMail.concat(action.payload),
      };
    }
    case PHARMA_ON_OPTION_MENU_SELECT: {
      return { ...state, optionMenuState: !state.optionMenuState };
    }
    case PHARMA_GET_NAV_FOLDER: {
      const filterMails = state.allMail.filter(
        (mail) => mail.folder === action.payload.id
      );
      return {
        ...state,
        selectedFolder: action.payload.id,
        noContentFoundMessage: "No hay pacientes en este espacio",
        currentMail: null,
        loader: true,
        folderMails: filterMails,
      };
    }

    case PHARMA_ON_START_SELECT: {
      action.payload.starred = !action.payload.starred;
      return {
        ...state,
        alertMessage: action.payload.starred
          ? "Mail Mark as Star"
          : "Mail Remove as Star",
        showMessage: true,
        folderMails: state.folderMails.map((mail) =>
          mail.id === action.payload.id ? action.payload : mail
        ),
      };
    }

    case PHARMA_SEARCH_MAIL: {
      if (action.payload === "") {
        return {
          ...state,
          folderMails: state.allMail.filter((mail) => !mail.deleted),
        };
      } else {
        const searchMails = state.allMail.filter(
          (mail) =>
            !mail.deleted &&
            mail.subject.toLowerCase().indexOf(action.payload.toLowerCase()) >
              -1
        );
        return {
          ...state,
          folderMails: searchMails,
        };
      }
    }

    case UPDATE_SEARCH: {
      return { ...state, searchMail: action.payload };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    case ON_TOGGLE_DRAWER: {
      return { ...state, drawerState: !state.drawerState };
    }
    case PHARMA_SET_CURRENT_MAIL_NULL: {
      return { ...state, currentMail: null };
    }
    case PHARMA_ON_DELETE_MAIL: {
      const mails = state.allMail.map((mail) =>
        mail.selected && mail.folder === state.selectedFolder
          ? { ...mail, folder: 4, selected: false }
          : mail
      );

      return {
        ...state,
        alertMessage: "Mail Deleted Successfully",
        showMessage: true,
        selectedMails: 0,
        allMail: mails,
        folderMails: mails.filter(
          (mail) => mail.folder === state.selectedFolder
        ),
      };
    }
    case PHARMA_ON_COMPOSE_MAIL: {
      return { ...state, composeMail: true };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }

    default:
      return state;
  }
};
